import React, { useEffect } from "react";
import { useContent } from "../context/ContentContext";
import { P_LOGO_URL } from "../lib/api";
import Nav from "../components/site/Nav";
import Hero from "../components/site/Hero";
import MarqueeBar from "../components/site/Marquee";
import Services from "../components/site/Services";
import About from "../components/site/About";
import Process from "../components/site/Process";
import Portfolio from "../components/site/Portfolio";
import Contact from "../components/site/Contact";
import Footer from "../components/site/Footer";
import TypedSection from "../components/site/TypedSection";
import ContentError from "../components/site/ContentError";

const BUILTINS = {
  marquee: MarqueeBar,
  services: Services,
  about: About,
  process: Process,
  portfolio: Portfolio,
  contact: Contact,
};

function applySeo(seo) {
  if (!seo) return;
  if (seo.title) document.title = seo.title;
  const setMeta = (selector, attr, name, value) => {
    if (!value) return;
    let el = document.head.querySelector(selector);
    if (!el) {
      el = document.createElement("meta");
      el.setAttribute(attr, name);
      document.head.appendChild(el);
    }
    el.setAttribute("content", value);
  };
  setMeta('meta[name="description"]', "name", "description", seo.description);
  setMeta('meta[property="og:title"]', "property", "og:title", seo.title);
  setMeta('meta[property="og:description"]', "property", "og:description", seo.description);
  setMeta('meta[name="twitter:title"]', "name", "twitter:title", seo.title);
  setMeta('meta[name="twitter:description"]', "name", "twitter:description", seo.description);
}

export default function Landing() {
  const { content, loading, error, retry } = useContent();

  useEffect(() => {
    if (content?.seo) applySeo(content.seo);
  }, [content]);

  if (error && !content) return <ContentError onRetry={retry} />;

  if (loading || !content) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-peca-black">
        <div className="flex flex-col items-center gap-4">
          <img src={P_LOGO_URL} alt="Peça" className="w-16 h-16 floaty" />
          <span className="label-mono text-peca-grey">A carregar…</span>
        </div>
      </div>
    );
  }

  const vis = (k) => content?.visibility?.[k] !== false;
  const blocks = content.homeBlocks && content.homeBlocks.length
    ? content.homeBlocks
    : [
        { kind: "builtin", key: "marquee" },
        { kind: "builtin", key: "services" },
        { kind: "builtin", key: "about" },
        { kind: "builtin", key: "process" },
        { kind: "builtin", key: "portfolio" },
        { kind: "builtin", key: "contact" },
      ];

  return (
    <div data-testid="landing-page" className="relative">
      <Nav content={content} />
      <main>
        <Hero content={content} />
        {blocks.map((b, i) => {
          if (b.kind === "builtin") {
            const Comp = BUILTINS[b.key];
            if (!Comp || !vis(b.key)) return null;
            return <Comp key={`b-${b.key}`} content={content} />;
          }
          return <TypedSection key={b.id || `c-${i}`} section={b} />;
        })}
      </main>
      <Footer content={content} />
    </div>
  );
}
